import { render, staticRenderFns } from "./product_producer_information.vue?vue&type=template&id=d08a897e&scoped=true&"
import script from "./product_producer_information.vue?vue&type=script&lang=js&"
export * from "./product_producer_information.vue?vue&type=script&lang=js&"
import style0 from "./product_producer_information.vue?vue&type=style&index=0&id=d08a897e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08a897e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d08a897e')) {
      api.createRecord('d08a897e', component.options)
    } else {
      api.reload('d08a897e', component.options)
    }
    module.hot.accept("./product_producer_information.vue?vue&type=template&id=d08a897e&scoped=true&", function () {
      api.rerender('d08a897e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_producer_information.vue"
export default component.exports